/**
 * Created by Alex Aguilar on 5/10/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('itineraryCtrl', itineraryCtrl)
        .controller('newItineraryCtrl', newItineraryCtrl)
        .controller('editItineraryCtrl', editItineraryCtrl)
        .controller('disableItineraryCtrl', disableItineraryCtrl)
        .controller('enableItineraryCtrl', enableItineraryCtrl);

    itineraryCtrl.$inject = ['linkService','itineraries', 'itinerariesDisabled'];
    newItineraryCtrl.$inject = ['itineraryService'];
    editItineraryCtrl.$inject = ['$stateParams', 'itineraryService','itinerary'];
    disableItineraryCtrl.$inject = ['$stateParams', '$uibModalInstance', 'itineraryService', 'itinerary'];
    enableItineraryCtrl.$inject = ['$stateParams', '$uibModalInstance', 'itineraryService', 'itinerary'];

    function itineraryCtrl(linkService,itineraries, itinerariesDisabled){
        var vm = this;
        vm.pages = [];
        vm.itineraries = (itineraries.data._embedded) ? itineraries.data._embedded.itineraries : [];
        vm.pages = itineraries.data.page;
        vm.itineraryDisabled = [];
        vm.itinerariesDisable = (itinerariesDisabled.data._embedded) ? itinerariesDisabled.data._embedded.itineraries : [];
        vm.contItineraryDisable = (vm.itinerariesDisable).length;
        vm.listDisabled = false;
        vm.disabled = true;
        vm.hide = false;
        vm.linkService = linkService;

        vm.showDisabled = function(){
            vm.listDisabled = true;
            vm.disabled = false;
            vm.hide = true;
        }

        vm.hideDisabled = function(){
            vm.listDisabled = false;
            vm.disabled = true;
            vm.hide = false;
        }
    };
    function newItineraryCtrl(itineraryService){
        var vm = this;

        vm.saveItinerary = function(isValid, itinerary){
            if(isValid){
                itinerary.active = true;
                itineraryService.saveItinerary(itinerary);
            }
        }
    }
    function editItineraryCtrl($stateParams, itineraryService, itinerary){
        var vm = this;
        vm.id = $stateParams.id;
        vm.itinerary = itinerary.data;
        vm.old = angular.copy(vm.itinerary);
        vm.buttonSave = true;

        vm.saveItinerary = function(isValid, itinerary){
            if(isValid){
                itinerary.active = true;
                itineraryService.updateItinerary(itinerary, vm.id);
            }
        }

        vm.change = function(){
            if(vm.itinerary.name.toUpperCase()==vm.old.name.toUpperCase()){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }
    }
    function disableItineraryCtrl($stateParams, $uibModalInstance, itineraryService, itinerary){
        var vm = this;
        vm.itineraryId = $stateParams.id;
        vm.itinerary = itinerary.data;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDisableItinerary = function(){
            itineraryService.deleteItinerary(vm.itineraryId)
                .then(function(){
                    $uibModalInstance.close(true);
                }, function(){
                    $uibModalInstance.close(true);
                })
        }
    }
    function enableItineraryCtrl($stateParams, $uibModalInstance, itineraryService, itinerary){
        var vm = this;
        vm.itineraryId = $stateParams.id;
        vm.itinerary = itinerary.data;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmEnableItinerary = function(){
            itineraryService.enableItinerary(vm.itineraryId)
                .then(function(){
                    $uibModalInstance.close(true);
                }, function(){
                    $uibModalInstance.close(true);
                })
        }
    }

})();
